module.exports = __webpack_public_path__ + "static/media/github-stars.fd15fe26.svg";